import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

// Custom.
import { ReportProps } from "../global";
import I18n from "@vocollege/app/dist/modules/Services/I18n";

const Report: React.FC<ReportProps> = (props) => {
  const { children, title, subtitle, summary, date, interval } = props;
  return (
    <Box
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[100]}`,
        borderRadius: 1,
        margin: "0 auto",
        maxWidth: 700,
        padding: 2,
      })}>
      <Box sx={{ alignItems: "flex-start", display: "flex", mb: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs>
            <Typography component="h1" variant="h4" sx={{ flex: 1 }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography component="div" sx={{ mt: 1 }}>
                {subtitle}
              </Typography>
            )}
          </Grid>
          <Grid item>
            {interval && (
              <Typography
                sx={{ textAlign: "right" }}
                component="div"
                variant="caption">
                {interval}
              </Typography>
            )}
            {date && (
              <Typography
                sx={{ textAlign: "right" }}
                component="div"
                variant="caption">
                {`${I18n.get.misc.created_at} ${date}`}
              </Typography>
            )}
          </Grid>
          {summary && (
            <Grid item xs={12}>
              {summary}
            </Grid>
          )}
        </Grid>
      </Box>

      {children}
    </Box>
  );
};

export default Report;
